"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixLineBreaks = void 0;
function fixLineBreaks(text) {
    return (text
        // cleans more than two contiguous line-breaks
        .replace(/\n{2,}/g, "\n\n"));
}
exports.fixLineBreaks = fixLineBreaks;
